import { Uploader } from 'components/Uploader';
import { useUploadAreaContext } from 'components/UploadArea/UploadAreaProvider/context';

export const ImageUploader = (): JSX.Element => {
  const { onDrop, mediaType, dropzoneOptions } = useUploadAreaContext();

  return (
    <div data-testid="image-upload-area">
      <Uploader onDrop={onDrop} mediaType={mediaType} dropzoneOptions={dropzoneOptions} height="210px" />
    </div>
  );
};
